export namespace Global {
    export let TriggerDomId: string = '';

    //Not used class. Trick to avoid compiling issues for TriggerDomId not been reasigned, so const should be used instead of let
    export class SetTrigger {
        static InitTrigger() {
            TriggerDomId = "";
        }
    }
}